import { fetchApi } from './api';
import { API_ENDPOINTS } from '../config';

// Day mapping: JavaScript (0=Sunday) -> API (0=Sunday, 6=Saturday)
const dayToApi = {
  'Sunday': 0,
  'Monday': 1,
  'Tuesday': 2,
  'Wednesday': 3,
  'Thursday': 4,
  'Friday': 5,
  'Saturday': 6,
};

const apiToDay = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

// Convert API format to internal format
const fromApiFormat = (apiHours) => {
  const result = {};
  apiHours.forEach((item) => {
    const day = apiToDay[item.day_of_week];
    if (day) {
      result[day] = {
        id: item.id,
        from: item.open_time ? item.open_time.substring(0, 5) : '',
        to: item.close_time ? item.close_time.substring(0, 5) : '',
        closed: item.is_closed || false,
      };
    }
  });
  return result;
};

export const getShopHours = async (shopId) => {
  const data = await fetchApi(API_ENDPOINTS.shopHours(shopId), { method: 'GET' });
  
  // Handle array response from API
  if (Array.isArray(data)) {
    return fromApiFormat(data);
  }
  
  // Handle wrapped response
  if (data && Array.isArray(data.data)) {
    return fromApiFormat(data.data);
  }
  
  // Return empty object if no data, letting the component handle defaults
  return {};
};

export const createShopHours = async (shopId, day, hoursData) => {
  const payload = {
    shopId,
    day_of_week: dayToApi[day],
    open_time: hoursData.from ? `${hoursData.from}:00` : null,
    close_time: hoursData.to ? `${hoursData.to}:00` : null,
    is_closed: hoursData.closed || false,
  };

  return fetchApi(API_ENDPOINTS.createShopHours, {
    method: 'POST',
    body: payload,
  });
};

export const updateShopHours = async (shopHoursId, hoursData) => {
  const payload = {
    open_time: hoursData.from ? `${hoursData.from}:00` : null,
    close_time: hoursData.to ? `${hoursData.to}:00` : null,
    is_closed: hoursData.closed || false,
  };

  return fetchApi(API_ENDPOINTS.updateShopHours(shopHoursId), {
    method: 'PUT',
    body: payload,
  });
};

// Combined save function that decides whether to POST or PUT
export const saveShopHours = async (shopId, day, hoursData) => {
  if (hoursData.id) {
    // If ID exists, update existing record
    return updateShopHours(hoursData.id, hoursData);
  } else {
    // If no ID, create new record
    return createShopHours(shopId, day, hoursData);
  }
};

